"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = require("./Modal.style"); // import { Container } from '../Layout'

/**
 * A Modal component to display over pages
 * State needs to be handled outside of the modal
 * An example of the state code can be found at the bottom of this page
 * @param {boolean} [isOpen=false] Determines if the Modal renders or returns null (Optional)
 * @param {(React.element|string)} [header=null] A string or React Element that renders in the header section (Optional)
 * @param {(React.element|string)} [title=null] A string or React Element that renders in the title section (Optional)
 * @param {(React.element|string)} [footer=null] A string or React Element that renders in the footer section (Optional)
 * @param {(React.element|string)} children A string or React Element that renders in the body of the component (Required)
 * @param {(React.element|string)} [size=null] Sets the width of the Modal to either 30% from "sm", 80% from "lg", or defaults to "md" 50%
 * @param {function} [closeModal] Passes the function to close the modal to the Component's wrapper so that clicks outside the modal will close it (Optional)
 * @returns {(React.element|null)} Returns the Modal Element or null
 */


var Modal = function Modal(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      children = _ref.children,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$closeModal = _ref.closeModal,
      closeModal = _ref$closeModal === void 0 ? null : _ref$closeModal;

  if (!isOpen) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "modal_div"
  }, /*#__PURE__*/_react.default.createElement(_Modal.ModalWrapper, {
    onClick: closeModal,
    "data-testid": "modal_wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Modal.ModalContent, {
    "data-testid": "modal_content",
    onClick: function onClick(e) {
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();
      return false;
    },
    size: size
  }, header && /*#__PURE__*/_react.default.createElement(_Modal.ModalHeader, {
    "data-testid": "modal_header"
  }, header), title && /*#__PURE__*/_react.default.createElement(_Modal.ModalTitle, {
    "data-testid": "modal_title"
  }, title), /*#__PURE__*/_react.default.createElement(_Modal.ModalBody, {
    "data-testid": "modal_body"
  }, children), footer && /*#__PURE__*/_react.default.createElement(_Modal.ModalFooter, {
    "data-testid": "modal_footer"
  }, footer))));
};
/**
 * The Prop Types that can be passed to the element
 */


Modal.propTypes = {
  isOpen: _propTypes.default.bool,
  title: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  header: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  footer: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  size: _propTypes.default.oneOf(['sm', 'md', 'lg']),
  closeModal: _propTypes.default.func
};
/**
 * The Default Prop Types when the element receives nothing
 */

Modal.defaultProps = {
  isOpen: false,
  title: null,
  header: null,
  footer: null,
  children: null,
  size: 'md',
  closeModal: null
};
var _default = Modal; // /**
//  * The following is an example of the simplest wrapper to open and close the modal component
//  */
// const ComponentUsingModal = () => {
//
//   const [isOpen, setIsOpen] = useState(false)
//
//     return (
//       <div>
//         <button type="button" onClick={() => setIsOpen(true)}>Open Modal</button>
//         <Modal
//           isOpen={isOpen}
//           closeModal={setIsOpen(false)}
//         >
//           <button type="button" onClick={() => setIsOpen(false)}>Close Modal</button>
//         </Modal>
//       </div>
//     )
// }

exports.default = _default;